var App = App || {};

App.Header = (function ($) {
    "use strict";

    var $login,
        $trigger,
        $loginWrapper;

    function init() {
        $login = $('.header-primary__login__container');
        $loginWrapper = $('.header-primary__login__container .login__wrapper');
        $trigger = $(".btn-login-toggle");

        $trigger.on('click', function (e) {

            if (!$trigger.hasClass('header-primary__login--open')) {
                e.preventDefault();
                openLogin($trigger);
            }
            else {
                closeLogin($trigger);
                App.Base.removeOverlay();
            }

            //left
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                $trigger.prev('li')
                    .find(' > a')
                    .trigger('focus');
            }

            //right
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                $trigger.next('li')
                    .find(' > a')
                    .trigger('focus');
            }

            //down
            if ($login.hasClass('header-primary__login--open') && e.key === 'ArrowDown') {
                e.preventDefault();
            }
        });


        $('#login-form').on('submit', function (e) {
            setTimeout(() => {
                this.reset();
            }, 100);
        });

    }


    function encode() {
        document.querySelector('#UserName').value = encodeURIComponent(document.querySelector('#UserName').value);
        document.querySelector('#Password').value = encodeURIComponent(document.querySelector('#Password').value);
    }




    function openLogin($item) {
        App.Base.$body.trigger('click');
        App.Base.addOverlay();

        $item
            .addClass('header-primary__login--open')
            .attr('aria-expanded', 'true');

        $login
            .addClass('d-flex');

        $loginWrapper
            .slideDown(300);

    }

    function closeLogin($item) {
        if ($item.hasClass('header-primary__login--open')) {

            $item
                .removeClass('header-primary__login--open')
                .attr('aria-expanded', 'false');

            $login
                .removeClass('d-flex');

            $loginWrapper
                .slideUp(300)
        }

    }

    return {
        init: init,
        encode: encode,
        closeLogin: closeLogin
    };
})(jQuery);

$(function () {
    App.Header.init();
});